// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML } from 'src/lib/utils.js';


// Stateful components

export const ReactQuestionSlider = (props) => {

    const [{ userData,  globalText} , dispatch] = useStateValue();

    const {question} = props;
    const sliderLabels = question.rangeSliderLabels.split('; ');

    // Handle slider value change (via mouseup or onBlur)
    const handleSliderChange = (event) =>  {
       // console.log('handleSliderChange');
        let sliderId = event.target.name;
        let newValue = Number(event.target.value);

        if (newValue !== userData.questionResponses[sliderId]) {
            dispatch({
                type: 'sliderValueUpdated',
                value: {
                    userResponse: {
                        key: sliderId,
                        value: newValue
                    }
                }
            });
        }        
    }

    // Handle disabled checkbox change
    const handleDisableCheckbox = (event) => {
        
        let sliderId = event.target.name;
        let newValue = 0;

        // If checkbox is already disabled, set back to default value of 1
        if (userData.questionResponses[sliderId] === 0) {
            newValue = 1;
        }

        dispatch({
            type: 'sliderValueUpdated',
            value: {
                userResponse: {
                    key: sliderId,
                    value: newValue
                }
            }
        });
    }

    // Render slider component
    const Slider = (question) => {
        var sliderStepElements = "";
        question = question.question; // for some reason it's nested itself.
        let selectedValue = userData.questionResponses[question.assetID] ? userData.questionResponses[question.assetID] : '1';
        let isDisabled = userData.questionResponses[question.assetID] === 0 ? true : false;
        let labelIndex = selectedValue > 0 ? selectedValue - 1 : 0;
        
        for(var i = 0; i < question.rangeSliderMax; i++) { 
            sliderStepElements += "<li role='presentation'></li>";
        }

        return (
            <div className={"br-app-main-content__contents__question-range" + (isDisabled ? " disabled" : "")}>
                <ul className="br-app-main-content__contents__question-range__points" role="presentation" dangerouslySetInnerHTML={dangerousHTML(sliderStepElements)}></ul>
                <input 
                    key={"sliderInput__" + question.assetID} 
                    type="range" 
                    name={question.assetID}
                    className="br-app-main-content__contents__question-range__input" 
                    min={question.rangeSliderMin ? question.rangeSliderMin : 1} 
                    max={question.rangeSliderMax ? question.rangeSliderMax : 5}  
                    defaultValue={selectedValue}
                    step="1"
                    aria-valuemin={question.rangeSliderMin ? question.rangeSliderMin : 1} 
                    aria-valuemax={question.rangeSliderMax ? question.rangeSliderMax : 5}
                    aria-label={question.rangeSliderAriaLabel}
                    aria-valuenow={selectedValue}
                    aria-valuetext={sliderLabels[labelIndex]}
                    onMouseUp={handleSliderChange}
                    onBlur={handleSliderChange}
                    onTouchEnd={handleSliderChange}
                    onChange={updateSliderValues}
                    disabled={isDisabled}
                    role="slider"

                />
            </div>
        )
    }

    const updateSliderValues = () => {
        //console.log('updateSliderValues');
         // Update slider aria values on any input change (even when state is not updated eg. keyUp)
         var sliderElements = document.querySelectorAll('.br-app-main-content__contents__question-range__input');

         // Loop over each range slider and add event listener for change and update aria-valuenow and aria-valuetext
         sliderElements.forEach((rangeSlider) => {
 
             rangeSlider.oninput = () => {
                 var rangeSliderVal = parseInt(rangeSlider.value, 10); // remove 1 cos array starts at 0, slider starts at 1
 
                 rangeSlider.setAttribute("aria-valuenow", rangeSliderVal.toString());
                 rangeSlider.setAttribute("aria-valuetext", sliderLabels[rangeSliderVal-1]); // remove 1 cos array starts at 0, slider starts at 1
             }
         })
    }

    

    // After render
    React.useEffect(() => {

        // Init slider state as '1' in questionResponses if it doesn't already exist
        if (typeof(userData.questionResponses[question.assetID]) === 'undefined') {
            dispatch({
                type: 'sliderValueUpdated',
                value: {
                    userResponse: {
                        key: question.assetID,
                        value: 1
                    }
                }
            });
        }

       // updateSliderValues();

    });

   // rangeSliderShowNA
    const SliderNA = () => {
        if( question.rangeSliderShowNA !== 'true'){
            return <></>;
        }
        return <label className="br-app-main-content__contents__question-range__question-toggle">
        <input type="checkbox" name={question.assetID} onChange={handleDisableCheckbox} defaultChecked={userData.questionResponses[question.assetID] === 0 ? true : false}/>
        <span className="br-app-main-content__contents__question-range__question-toggle__checkbox"></span>
        <span>N/A</span>
    </label>
    }

    // Render component
    return (
        <div className="br-app-main-content__contents__question">
            <div className="br-app-main-content__contents__question-range__header">
                <h3>{question.headerText}</h3>
                <SliderNA></SliderNA>
            </div>
            <div className="br-app-main-content__contents__question-range__content" dangerouslySetInnerHTML={dangerousHTML(question.content)}></div>
            <Slider key={"slider__" + question.assetID} question={question}/>
            <ul className="br-app-main-content__contents__question-range__labels">
                <li>{globalText.questionSliderLabelLeft}</li>
                <li>{globalText.questionSliderLabelRight}</li>
            </ul>
        </div>
    );    
};
